<template>
  <div>
    <h5 v-if="caption">{{ caption }}</h5>
    <!-- Overrides `content` prop -->
    <slot>{{ content }}</slot>
    <ul v-if="lines" class="-unstyled">
      <li v-for="(line, index) in lines" :key="index"><rui-icon-text v-bind="line" /></li>
    </ul>
  </div>
</template>

<script>
import RuiIconText from '../IconText/IconText.vue'

/**
 * Use this component with `HelpButton`, as `content` slot.
 *
 * @preset Default {
 *                   "props": {
 *                     "caption": "Button meanings and actions",
 *                     "content": "The following icons are often seen on the interface:",
 *                     "lines": [
 *                       { "icon": "home", "text": "Brings you home" },
 *                       { "icon": "trash", "text": "Destroys the item", "variant": "danger" },
 *                       { "icon": "pencil", "text": "Display edition form" }
 *                     ]
 *                   }
 *                 }
 */
export default {
  name: 'RuiHelpButtonContent',
  components: { RuiIconText },
  props: {
    /** Help title */
    caption: { required: false, type: String, default: null },
    /** Content text. Is overridden by default slot */
    content: { required: false, type: String, default: null },
    /**
     * List of IconText props to create a list of help points.
     * ex: `[{ icon: 'map-pin', text: 'some description' }]`
     *
     * It is displayed _after_ the content.
     */
    lines: { required: false, type: Array, default: null },
  },
}
</script>
